export const CLINICAL_VERTICALS = [
  { value: "psych", label: "Psihologie / psihoterapie" },
  { value: "physio", label: "Fizioterapie" },
  { value: "kineto", label: "Kinetoterapie" },
  { value: "speech", label: "Logopedie" },
  { value: "nutrition", label: "Nutriție / dietetică" },
  { value: "osteo", label: "Osteopatie / masaj" },
  { value: "home_care", label: "Îngrijire la domiciliu" },
]

export const CARE_PLAN_MODALITIES = [
  { value: "psych", label: "Psihologie — plan terapeutic", verticals: ["psych"] },
  { value: "physio", label: "Fizioterapie", verticals: ["physio"] },
  { value: "kineto", label: "Kinetoterapie", verticals: ["kineto"] },
  { value: "speech", label: "Logopedie", verticals: ["speech"] },
  { value: "nutrition", label: "Nutriție", verticals: ["nutrition"] },
  { value: "osteo", label: "Osteopatie / masaj", verticals: ["osteo"] },
  { value: "pis", label: "PIS – asistent personal", verticals: ["home_care"] },
]

export const HR_ROLE_TO_VERTICAL = {
  psiholog: "psych",
  fizioterapeut: "physio",
  kinetoterapeut: "kineto",
  logoped: "speech",
  nutritionist: "nutrition",
}

export const SESSION_VERTICAL_KEY = "asistentpersonal-working-vertical"

export function getSessionVertical() {
  try {
    return localStorage.getItem(SESSION_VERTICAL_KEY) || ""
  } catch {
    return ""
  }
}

export function setSessionVertical(value) {
  try {
    if (value) localStorage.setItem(SESSION_VERTICAL_KEY, value)
    else localStorage.removeItem(SESSION_VERTICAL_KEY)
  } catch {
    /* ignore */
  }
}

export function modalitiesForVerticals(enabledVerticals) {
  const set = new Set(enabledVerticals || [])
  return CARE_PLAN_MODALITIES.filter((m) => m.verticals.some((v) => set.has(v)))
}

export function labelForVertical(value) {
  return CLINICAL_VERTICALS.find((v) => v.value === value)?.label || value
}
